/**
 * @desc 出金申请提交
 */
import { WithdrawApplyForm } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateWithDrawApplyParameter = WithdrawApplyForm

const method = 'POST'
const url = '/finance/finance/withdraw/creat'

export const createWithDrawApplyApi = (
  data?: CreateWithDrawApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createWithDrawApplyApi.method = method
createWithDrawApplyApi.url = url
